<template>
  <div class="test-body">
    <h1 class="test-body_title">Тест для определения уровня <span>иностранного языка</span></h1>
    <div class="test-body_message">
    <span class="test-body_colored">Если вы решили пройти онлайн тест,
      это значит, что вы уже на верном пути.</span><br><br>
      <span class="test-body_colored">Первый этап</span> в изучении языков - это объективная проверка текущего уровня
      владения языком. Качество обучения — это наша приоритетная задача. Именно поэтому мы тщательно относимся к
      проверке текущего уровня. Так
      как от этого зависит ваш комфорт и результативность обучения.
      <br><br>
      <span class="test-body_colored" style="font-size: 18px;">Пройдите онлайн тесты по     английскому и другим иностранным языкам.</span><br><br>
    </div>
    <div class="test-body_choose-language">
      <span>ВЫБЕРИТЕ ЯЗЫК ДЛЯ ОПРЕДЕЛЕНИЯ УРОВНЯ</span><br>
      <div class="test-body_choose-language_languages">
        <div class="test-body_choose-language_block" v-for="lang in languages" @click="loadCategory(lang,$event)">
          <img v-if="lang.ico" :src="lang.ico"><br> {{ lang.name }}
        </div>
      </div>
      <div class="buttons_category" v-if="categories.length > 0">
        <div v-for="cat in categories" :data-id="cat.id" @click="checkCat(cat,$event)">{{ cat.name }}</div>
      </div>

      <!-- <div class="test-body_choose-language">
        <div class="test-body_choose-language_languages">
          <div class="test-body_choose-language_block" style="width: 20%;">
            <a href="/schools/globus2/"><img src="/quiz/images/china.jpg"></a><br> КИТАЙСКИЙ
          </div>

          <div class="test-body_choose-language_block" style="width: 20%;">
            <a href="/schools/globus2/"><img src="/quiz/images/japan.png"></a><br> ЯПОНСКИЙ
          </div>
        </div>
      </div> -->

      <div class="test-body_choose-language_submit-button">
        <div class="form-submit index-page" :class="{checked: !isChecked}" @click="isNextStep">
          <input type="submit" onclick="yaCounter44990620.reachGoal('start_test'); return true;" id="start_test"
                 value="Продолжить"/>
        </div>
      </div>


      <div class="test-body_message">
        <span class="test-body_colored">Обращаем внимание:</span><br><br>

        Алгоритм тестирования построен таким образом, что в процессе прохождения программа анализирует количество
        правильных ответов. Поэтому тест может быть завершен автоматически, если
        будет превышено допустимое число ошибок.<br><br> Результаты письменного тестирования не отражает всю полноту
        знаний и для правильных рекомендаций важно пройти устное тестирование с нашим преподавателей в одной из школ
        ВКС-Ih.
        <br><br><br><br>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'StepOne',
  data() {
    return {
      languages: '',
      categories: '',
      langId: 0,
      catId: 0
    }
  },
  mounted: function () {

    axios.get('/quiz/api/language.php?lang').then(response => {
      this.languages = response.data;
    }).catch(error => {
      console.log(error)
    })
  },
  computed: {
    isChecked: function () {
      return (this.langId > 0 && this.catId > 0)
    }
  },
  methods: {
    isNextStep: function (e) {
      if (this.isChecked) {
        this.$router
          .push(`/step-two/${this.langId}/${this.catId}`)
      }
    },
    loadCategory: function (lang, e) {
      let $lang = $(e.currentTarget);
      this.langId = lang.id;

      $('.test-select-lang').removeClass('active');
      $lang.addClass('active');

      axios.get(`/quiz/api/language.php?category=${lang.id}`).then(response => {
        this.categories = response.data;
        this.resetCat();
      }).catch(error => {
        console.log(error)
      })
    },
    checkCat: function (cat, e) {
      let $cat = $(e.currentTarget);

      this.resetCat();
      $cat.addClass('active');

      this.catId = cat.id;
    },

    resetCat: function () {
      $('.buttons_category div').removeClass('active');
      this.catId = 0;
    }
  }
}
</script>

<style lang="sass">

.container-test .content--test
  @media screen and (max-width: 1200px)
    padding-top: 0
    margin-top: -20px

.content-wrap
  .test-wrapper
    .step_name--head
      margin-bottom: 0px
      padding-bottom: 0px

.step_name
  &--text
    font-size: 14px

    p
      margin-top: 0px
      margin-bottom: 15px
      padding: 10px 25px


  &--head
    margin-bottom: 0px

.step_list
  &--test
    padding-left: 20px

.buttons_category
  text-align:

  div.active
    background: #6ed9de !important
    color: #fff

.test-wrapper
  .step_name
    font-size: 14px
    padding: 10px 15px

  .step_name--head
    margin-bottom: 0px

.test-select-langs
  &__head
    font-size: 20px

.test-select-lang-icon
  &--test
    background-size: cover
    background-repeat: no-repeat
    background-position: center center

</style>



// WEBPACK FOOTER //
// src/components/StepOne.vue